import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconRight: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <circle
        cx="12"
        cy="12"
        r="12"
        transform="rotate(-180 12 12)"
        fill="#F7F7F8"
      />
      <path d="M10 16.6665L14.6667 11.9998L10 7.33317" stroke="#262F56" />
    </Icon>
  );
};

export default IconRight;
